import React, { Component, ChangeEvent } from "react";
import Logo from "../../assets/img/TMNANewCTLogo.png";
import { withRouter } from "react-router-dom";
import * as config from "../../config";

import ProfileIcon from "../../assets/icons/profile-icon.svg";

import {
  MDBDropdown,
  MDBDropdownToggle,
  MDBDropdownMenu,
  MDBDropdownItem,
} from "mdb-react-ui-kit";
import axios from "axios";
import { useRoles } from "../../context/RolesContext";

interface HeaderState {
  selectedEnv: string;
}

const HeaderWithRoles = (props: any) => {
  const { roles } = useRoles();
  return <Header {...props} roles={roles} />;
};

class Header extends Component<any, HeaderState> {
  constructor(props: any) {
    super(props);

    let initialEnv = localStorage.getItem("selectedEnv") || "setdefault";
    if (initialEnv === "setdefault") {
      localStorage.setItem("selectedEnv", "tyau_sydney");
      initialEnv = "tyau_sydney";
    }

    this.state = {
      selectedEnv: initialEnv,
    };

    this.handleEnvChange = this.handleEnvChange.bind(this);
    this.syncEnvAcrossTabs = this.syncEnvAcrossTabs.bind(this);
  }

  componentDidMount() {
    window.addEventListener("storage", this.syncEnvAcrossTabs);
  }

  componentWillUnmount() {
    window.removeEventListener("storage", this.syncEnvAcrossTabs);
  }

  // handleEnvChange = (event: ChangeEvent<HTMLSelectElement>) => {
  //   const selectedEnv = event.target.value;

  //   this.setState({ selectedEnv }, () => {
  //     localStorage.setItem("selectedEnv", selectedEnv);

  //     const envChangeEvent = new CustomEvent("envChanged", { detail: selectedEnv });
  //     window.dispatchEvent(envChangeEvent);

  //     axios
  //       .post(
  //         config.rootUrl + "/v1/simulator/select-environment",
  //         { environment: selectedEnv },
  //         { headers: { "x-api-key": config.apiKey } }
  //       )
  //       .then((response) => console.log("Environment updated:", response.data))
  //       .catch((error) => console.error("Error selecting environment:", error));

  //     if (this.props.onEnvChange) this.props.onEnvChange(selectedEnv);
  //   });
  // };

  handleEnvChange = (event: ChangeEvent<HTMLSelectElement>) => {
    const selectedEnv = event.target.value;

    this.setState({ selectedEnv }, () => {
      localStorage.setItem("selectedEnv", selectedEnv);

      axios
        .post(
          config.rootUrl + "/v1/simulator/select-environment",
          { environment: selectedEnv },
          {
            headers: {
              "Content-Type": "application/json",
              "x-api-key": config.apiKey,
              Authorization: "Bearer " + this.props.jwtToken,
            },
          }
        )
        .then((response) => {
          console.log("Environment updated:", response.data);
          const envChangeEvent = new CustomEvent("envChanged", {
            detail: selectedEnv,
          });
          window.dispatchEvent(envChangeEvent);
          if (this.props.onEnvChange) this.props.onEnvChange(selectedEnv);
        })
        .catch((error) => console.error("Error selecting environment:", error));
    });
  };

  syncEnvAcrossTabs(event: StorageEvent) {
    if (event.key === "selectedEnv") {
      this.setState({ selectedEnv: event.newValue || "tyau_sydney" });
      this.props.onEnvChange(event.newValue || "tyau_sydney");
    }
  }

  render() {
    const { jwtName, jwtUserName, userName, userEmail, userRoles, logout } =
      this.props;
    const headerHeight = "60px";

    return (
      <>
        <header
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: headerHeight,
            zIndex: 9999,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            backgroundColor: "#ffffff",
            backgroundImage: `url(${require("../../assets/img/Toyota.jpg")})`,
            backgroundSize: "contain",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            padding: "0 20px",
          }}
        >
          <img
            src={Logo}
            alt="Logo"
            style={{
              maxWidth: "100%",
              maxHeight: "100%",
              backgroundColor: "#ffffff",
              paddingRight: "12px",
            }}
          />

          <div
            style={{
              display: "flex",
              alignItems: "center",
              paddingRight: "15rem",
              height: "100%",
              flexShrink: 0,
              backgroundColor: "#ffffff",
            }}
          >
            <label
              htmlFor="envSelect"
              style={{
                fontSize: "12px",
                whiteSpace: "nowrap",
                marginLeft: "5px",
                marginRight: "5px",
                paddingTop: "5px",
              }}
            >
              Environment:{" "}
            </label>

            <select
              id="envSelect"
              style={{ fontSize: "12px", width: "110px" }}
              value={this.state.selectedEnv}
              onChange={this.handleEnvChange}
            >
              <option value="tyau_sydney">tyau_sydney</option>
              <option value="devna_virginia">devna_virginia</option>
              <option value="devna_oregon">devna_oregon</option>
              <option value="ppna_virginia">ppna_virginia</option>
              <option value="ppna_oregon">ppna_oregon</option>
              <option value="tyin_mumbai">tyin_mumbai</option>
              <option value="tyeu_frankfurt">tyeu_frankfurt</option>
            </select>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                marginLeft: "15px",
              }}
            >
              <div style={{ fontWeight: 600 }}>{jwtName}</div>
              <div style={{ fontSize: "12px", color: "#6c757d" }}>
                {jwtUserName}
              </div>
            </div>

            <div
              style={{
                position: "relative",
                marginLeft: "45px",
                marginRight: "-100px",
                width: "32px",
                height: "32px",
              }}
            >
              <MDBDropdown>
                <MDBDropdownToggle
                  nav={false}
                  color="none"
                  style={{
                    padding: 0,
                    margin: 0,
                    width: "32px",
                    minWidth: "32px",
                    height: "32px",
                    display: "flex",
                    alignItems: "center",
                    backgroundColor: "transparent",
                    border: "none",
                    boxShadow: "none",
                  }}
                >
                  <img
                    src={ProfileIcon}
                    alt="Profile"
                    title="Profile"
                    style={{
                      cursor: "pointer",
                      width: "32px",
                      height: "32px",
                      borderRadius: "50%",
                      objectFit: "cover",
                      display: "block",
                    }}
                  />
                </MDBDropdownToggle>

                <MDBDropdownMenu
                  style={{
                    position: "absolute",
                    top: "100%",
                    right: 0,
                    minWidth: "220px",
                    padding: "10px",
                    borderRadius: "6px",
                    boxShadow: "0px 4px 12px rgba(0,0,0,0.1)",
                    fontSize: "14px",
                    backgroundColor: "#ffffff",
                  }}
                >
                  <MDBDropdownItem disabled style={{ padding: "8px 12px" }}>
                    <div style={{ fontWeight: 600 }}>{userName || "N/A"}</div>
                    <div style={{ fontSize: "12px", color: "#6c757d" }}>
                      {userEmail || "N/A"}
                    </div>
                  </MDBDropdownItem>

                  <MDBDropdownItem disabled style={{ padding: "8px 12px" }}>
                    <strong>Roles:</strong>{" "}
                    {userRoles.length > 0 ? userRoles.join(", ") : "None"}
                  </MDBDropdownItem>

                  <MDBDropdownItem divider style={{ margin: "4px 0" }} />

                  <MDBDropdownItem
                    onClick={logout}
                    style={{
                      padding: "8px 12px",
                      cursor: "pointer",
                      color: "#dc3545",
                      fontWeight: 500,
                    }}
                  >
                    Logout
                  </MDBDropdownItem>
                </MDBDropdownMenu>
              </MDBDropdown>
            </div>
          </div>
        </header>

        <div style={{ height: headerHeight }} />
      </>
    );
  }
}

export default withRouter(HeaderWithRoles);
